import { render, staticRenderFns } from "./LoadingShade.vue?vue&type=template&id=b4083318&scoped=true"
import script from "./LoadingShade.vue?vue&type=script&lang=js"
export * from "./LoadingShade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4083318",
  null
  
)

export default component.exports